import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {selectRedShadow, styleRedShadow} from '../../../utils/commonStyles';
import './RelatedPatternsInput.css';
import apiUrl from "../../../shared/config";
import DeleteButton from "../ExampleGamesInput/ExampleGameInputButtons/DeleteButton";
import {validStringField} from "../../../utils/utils";

class RelatedPatternsInput extends Component  {
    state = {
        patterns: [],
        related_patterns: [],
        hoveredRemoveIconGameIndex: null,
    };

    componentDidMount() {
        if (this.state.patterns !== []) {
            axios.get(apiUrl +'PatternList/getNames?token=' + this.props.token)
                .then(response => {
                    this.setState({patterns: response.data});
                });
        }

        // this opens a blank related pattern when you do not have a related game on the pattern.
        if (!this.props.relatedPatterns || (this.props.relatedPatterns && this.props.relatedPatterns.length === 0)) {
            this.props.relatedPatternUpdate([{
                    pattern_id: null,
                    related_pattern_id: null,
                    related_pattern_name: "",
                    pattern_relationship: "",
                    relationship_description: "",
                    relationship_confidence: null
                }])
        }

        this.setState({related_patterns: this.props.relatedPatterns});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            // this opens a blank related pattern when you do not have a related game on the pattern.
            if (!this.props.relatedPatterns || (this.props.relatedPatterns && this.props.relatedPatterns.length === 0)) {
                this.props.relatedPatternUpdate([{
                    pattern_id: null,
                    related_pattern_id: null,
                    related_pattern_name: "",
                    pattern_relationship: "",
                    relationship_description: "",
                    relationship_confidence: null
                }])
            }


            this.setState({related_patterns: this.props.relatedPatterns});
        }
    }

    addRelatedPattern = () => {
        const new_value = [
            ...this.state.related_patterns,
            {
                pattern_id: null,
                related_pattern_id: null,
                related_pattern_name: "",
                pattern_relationship: "",
                relationship_description: "",
                relationship_confidence: null
            }];
        this.props.relatedPatternUpdate(new_value)
        this.setState(
            {related_patterns: new_value});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let relatedPatternsInputElement = null;
        if (this.state.patterns && this.state.patterns.length) {
            const patternOptions = this.state.patterns
                .map( pattern => ({value: pattern.pattern_id, label: pattern.pattern_name}));
            const related_patterns = [...this.state.related_patterns];
            if (related_patterns.length > 0) {
                let related_patterns_array_index = 0;
                relatedPatternsInputElement = (
                    <>
                        <dd className="col-sm-9">
                            {related_patterns.map(pattern => {


                                let related_index_local = related_patterns_array_index;
                                const related_pattern_id = related_patterns[related_index_local].related_pattern_id;
                                const default_index = this.arraySearch(patternOptions, related_pattern_id);
                                let default_value = {label: "Select a related pattern."};
                                if (related_pattern_id !== null) {
                                    default_value = patternOptions[default_index];
                                }

                                const allBlank = !related_pattern_id && !validStringField(pattern.relationship_description)
                                                && !related_patterns[related_index_local].pattern_relationship
                                                && !Number.isInteger(related_patterns[related_index_local].relationship_confidence)

                                const return_jsx = (
                                    <div className="related-pattern-block" key={related_pattern_id + " " + related_index_local}>
                                        <Select
                                            className="example-games-select-semi-full"
                                            styles={selectRedShadow(related_pattern_id || allBlank)}
                                            defaultValue={{
                                                value: related_pattern_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={patternOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                related_patterns[related_index_local] = {
                                                    related_pattern_id: val.value,
                                                    pattern_relationship: related_patterns[related_index_local].pattern_relationship,
                                                    relationship_description: related_patterns[related_index_local].relationship_description,
                                                    relationship_confidence: related_patterns[related_index_local].relationship_confidence
                                                };
                                                this.setState({related_patterns: related_patterns});
                                                this.props.relatedPatternUpdate(related_patterns);
                                            }}
                                        />
                                        <div style={{display: "flex", height: "35px",}}>
                                            <DeleteButton onDelete={() => {
                                                let filtered_array = related_patterns.filter((value, index, array) => {
                                                    return index !== (related_index_local)
                                                });
                                                this.setState({related_patterns: filtered_array});
                                                this.props.relatedPatternUpdate(filtered_array);
                                            }}/>
                                        </div>
                                        <div className="relationship-input">
                                            <Form.Control
                                                style={styleRedShadow(validStringField(pattern.relationship_description  || allBlank))}
                                                as="textarea"
                                                rows="2"
                                                placeholder="How is this pattern related?"
                                                value={pattern.relationship_description}
                                                onChange={(event) => {
                                                    related_patterns[related_index_local] = {
                                                        related_pattern_id: related_patterns[related_index_local].related_pattern_id,
                                                        pattern_relationship: related_patterns[related_index_local].pattern_relationship,
                                                        relationship_description: event.target.value,
                                                        relationship_confidence: related_patterns[related_index_local].relationship_confidence
                                                    };
                                                    this.setState({related_patterns: related_patterns});
                                                    this.props.relatedPatternUpdate(related_patterns);
                                                }}/>
                                        </div>
                                        <Select className="relationship-type"
                                            styles={selectRedShadow(related_patterns[related_index_local].pattern_relationship || allBlank)}
                                            options={[
                                                {value: "Parent", label: "Parent"},
                                                {value: "Child", label: "Child"},
                                                {value: "Additive", label: "Additive"},
                                                {value: "Subtractive", label: "Subtractive"},
                                                {value: "Alternate", label: "Alternate"}
                                            ]}
                                            defaultValue={{
                                                value: related_patterns[related_index_local].pattern_relationship,
                                                label: related_patterns[related_index_local].pattern_relationship,
                                                isFixed: true,
                                                isDisabled: true}}
                                            onChange={(val) => {
                                                let related_patterns = [...this.state.related_patterns];
                                                related_patterns[related_index_local] = {
                                                    related_pattern_id: related_patterns[related_index_local].related_pattern_id,
                                                    pattern_relationship: val.value,
                                                    relationship_description: related_patterns[related_index_local].relationship_description,
                                                    relationship_confidence: related_patterns[related_index_local].relationship_confidence
                                                };
                                                this.setState({related_patterns: related_patterns});
                                                this.props.relatedPatternUpdate(related_patterns);
                                            }}
                                            closeMenuOnSlelect={true}
                                        />
                                        <Select className="relationship-confidence"
                                                styles={selectRedShadow(Number.isInteger(related_patterns[related_index_local].relationship_confidence) || allBlank)}
                                                defaultValue={{
                                                    value: related_patterns[related_index_local].relationship_confidence,
                                                    label: related_patterns[related_index_local].relationship_confidence
                                                }}
                                                options={[
                                                {value: 0, label: 0},
                                                {value: 1, label: 1},
                                                {value: 2, label: 2},
                                                {value: 3, label: 3},
                                                {value: 4, label: 4},
                                                {value: 5, label: 5},
                                                {value: 6, label: 6}
                                            ]}
                                            onChange={(val) => {
                                                //let related_patterns = [...related_patterns];
                                                related_patterns[related_index_local] = {
                                                    related_pattern_id: related_patterns[related_index_local].related_pattern_id,
                                                    pattern_relationship: related_patterns[related_index_local].pattern_relationship,
                                                    relationship_description: related_patterns[related_index_local].relationship_description,
                                                    relationship_confidence: val.value
                                                };
                                                this.setState({related_patterns: related_patterns});
                                                this.props.relatedPatternUpdate(related_patterns);
                                            }}
                                            closeMenuOnSlelect={true}
                                        />
                                    </div>
                                );
                                related_patterns_array_index++;

                                return return_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </>
                );
            }
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Related Patterns</label></dt>
                {relatedPatternsInputElement}
                <dd className="col-sm-9"><Button className="col-sm-12" variant="outline-primary" onClick={this.addRelatedPattern}>Add Related Pattern</Button></dd>
            </dl>
            );
    }
}

export default RelatedPatternsInput;